import { ContractorUpdatableInterface } from '../interfaces/contractor-updatable.interface';
import { PartialType, PickType } from '@nestjs/swagger';
import { ContractorDto } from './contractor.dto';

export class ContractorUpdateDto
  extends PartialType(
    PickType(ContractorDto, [
      'name',
      'corporation',
      'description',
      'paymentType',
      'paymentRate',
      'hangerAvailable',
      'finisherAvailable',
      'sprayerAvailable',
      'bumperAvailable',
      'bumperPaymentType',
      'bumperPaymentRate',
      'paintAvailable',
      'trimAvailable',
      'specialistAvailable',
      'archived',
      'active',
      'suspended',
      'canPerformHighCeilingTasks',
      'notes',
      'hangerCapacity',
      'finisherCapacity',
      'sprayerCapacity',
      'specialistCapacity',
      'paintCapacity',
      'trimCapacity',
      'bumperCapacity',
    ]),
  )
  implements ContractorUpdatableInterface {}
